export default "__VITE_ASSET__DuRp0qYc__"